import { render, staticRenderFns } from "./AssignTemplateToSites.vue?vue&type=template&id=41acf0a4&"
import script from "./AssignTemplateToSites.vue?vue&type=script&lang=js&"
export * from "./AssignTemplateToSites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports